
varying vec3 vNormal;
varying vec3 vPosition;


uniform vec3 uSunDirection;

uniform vec3 uAtmosphereDayColor;
uniform vec3 uAtmosphereTwilightColor;

void main()
{
    vec3 viewDirection = normalize(vPosition - cameraPosition);
    vec3 normal = normalize(vNormal);
    vec3 color = vec3(0.0);


    float sunOrientation = dot(uSunDirection,normal);



    float atmosphereDayMix = smoothstep(-0.5,1.0, sunOrientation);
    vec3 atmosphereColor = mix(uAtmosphereTwilightColor,uAtmosphereDayColor,atmosphereDayMix);
    // color = mix(color,atmosphereColor,atmosphereDayMix);

    color +=atmosphereColor;

    float edgeAlpha = dot(viewDirection,normal);
    edgeAlpha = smoothstep(0.0,0.5,edgeAlpha);

    float dayAlpha = smoothstep(-0.5,0.0,sunOrientation);
    float alpha = dayAlpha*edgeAlpha;



    // Final color
    gl_FragColor = vec4(color, alpha);
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}